import { SyntheticEvent, useMemo } from 'react';
import { useNavigate, useHref } from 'react-router-dom';

interface ClickHref {
    href: string;
    onClick: (e: SyntheticEvent<HTMLElement>) => void;
}
export const useClickHref: (href: string) => ClickHref = href => {
    const navigate = useNavigate();
    const basename = useHref('/');

    return useMemo(
        () => ({
            href,
            onClick: (e: SyntheticEvent<HTMLElement>) => {
                e.stopPropagation();
                e.preventDefault();

                if (href) {
                    navigate(!basename || basename === '/' ? href : href.replace(basename, '/'));
                }
            },
        }),
        [navigate, href, basename]
    );
};
